module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only aligner",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md1": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInUp",
    attrs: {
      "imaSize": 40,
      "imaSrc": "design/banco3-1-1_2",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInLeft dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Qué pasa si sus ingresos son mayores a sus gastos?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v(" Qué pasa si sus ingresos "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("son mayores a")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" sus gastos? ")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Qué pasa si sus ingresos son mayores a sus gastos?',
      "videoEmbed": "ADMINISTRACIONDINERO41IngresosMayoresAGastos.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("Si sus ingresos son mayores a sus gastos, usted tiene "), _c('strong', [_vm._v("capacidad")]), _vm._v(" de\r\n        "), _c('tooltip', {
    staticClass: "tip font-red",
    attrs: {
      "texto": "ahorro",
      "tooltip": "Es la parte del ingreso que no se gasta, es decir, que voluntariamente se guarda para su uso futuro. Es una acción que consiste en guardar dinero en el presente para utilizarlo en el futuro.",
      "textPos": "text-top"
    }
  }), _vm._v(" y la posibilidad de construir o aumentar su\r\n        "), _c('tooltip', {
    staticClass: "tip font-red",
    attrs: {
      "texto": "patrimonio",
      "tooltip": "Es el conjunto de los bienes y derechos pertenecientes a una persona, natural o jurídica.",
      "textPos": "text-top"
    }
  }), _vm._v(".\r\n      ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md6": "",
      "mb-5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 450,
      "imaSrc": "contenido/diapositiva_42",
      "imaAlt": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a921298","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-41.vue
// module id = 1013
// module chunks = 1